import React, { useEffect, useRef } from "react";
import { LenguageTabla } from "../../Comunes/LenguajeTabla/LenguajeTabla";
import ReactDOM from "react-dom";
import moment from "moment";
import $ from "jquery";
import { Notificar } from "../../Comunes/Notificador";
import ModificarMotivoLiquidacionModal from "./ModificarMotivoLiquidacionModal";

function OperacionesModificarMotivoLiquidacion({
  motivosLiquidacion,
  operaciones,
  actualizarOperaciones = null,
  permiteSeleccionar = false,
  permiteEditar = false,
  permiteEliminar = false,
  soloLectura = false,
}) {
  const tableRef = useRef();

  useEffect(() => {
    const botonesTabla = permiteSeleccionar ? ["selectAll", "selectNone"] : [];
    const posicionDom = permiteSeleccionar
      ? '<"mb-3"B><"float-left"l><"text-right"f>rt<"float-left"i><"text-right"p>'
      : '<"float-left"l><"text-right"f>rt<"float-left"i><"text-right"p>';

    const tabla = $(tableRef.current).DataTable({
      language: LenguageTabla,
      paging: !permiteEditar,
      processing: true,
      destroy: true,
      data: operaciones,
      select: permiteSeleccionar && {
        style: "multi",
        selector: "td:first-child",
      },
      dom: posicionDom,
      buttons: botonesTabla,
      columns: [
        {
          title: "Selecionar",
          data: null,
        },
        {
          title: "Editar",
          data: null,
          createdCell: function (cell, cellData, rowData, rowIndex, colIndex) {
            function actualizarMotivoLiquidacion(operacion) {
              tabla.row(rowIndex).data(operacion).draw(false);
              actualizarOperaciones(tabla.rows().data().toArray());
            }

            ReactDOM.render(
              <div className="d-flex justify-content-between">
                <ModificarMotivoLiquidacionModal
                  motivoLiquidacion={cellData}
                  actualizarMotivoLiquidacion={actualizarMotivoLiquidacion}
                  cargarMotivos={motivosLiquidacion}
                />
              </div>,
              cell
            );
          },
          searchable: false,
          orderable: false,
          visible: permiteEditar,
        },
        {
          title: "Operación",
          data: "operacion",
        },
        {
          title: "Periodo",
          data: "fechaPeriodo",
          render: function (row) {
            return row !== null ? moment(row).format("DD/MM/YYYY") : "";
          },
        },
        {
          title: "Motivo de Liquidación Reportado",
          data: "motivoLiquidacionReportado",
          render: function (row) {
            return row === null ? "" : row.descripcionLarga;
          },
        },
        {
          title: "Motivo de Liquidación Propuesto",
          data: "motivoLiquidacionPropuesto",
          render: function (data) {
            return data?.codigo === null
              ? '<small class="text-muted">Sin asignar</small>'
              : data.descripcionLarga;
          },
          visible: permiteEditar || soloLectura,
        },
        {
          title: "Operación Nueva",
          data: "operacionNueva",
          visible: permiteEditar || soloLectura,
        },
        {
          title: "Excluir de Solicitud",
          data: null,
          defaultContent:
            "<center><button class='btn btn-danger btn-sm js-eliminar' title='Excluir de Solicitud'><i class='fa fa-trash'></i></button></center>",
          searchable: false,
          orderable: false,
          visible: permiteEditar,
        },
      ],
      columnDefs: [
        {
          targets: 0,
          defaultContent: "",
          className: "select-checkbox",
          searchable: false,
          orderable: false,
          visible: permiteSeleccionar,
        },
      ],
    });

    tabla.off("click");

    tabla.on("select deselect", function (e) {
      actualizarOperaciones(tabla.rows({ selected: true }).data().toArray());
    });

    tabla.on("click", ".js-eliminar", function () {
      if (tabla.rows().data().count() === 1) {
        Notificar(
          "error",
          "No se puede eliminar. La solicitud debe tener al menos una operación."
        );
        return;
      }

      tabla.row($(this).parents("tr")).remove().draw();
      actualizarOperaciones(tabla.rows().data().toArray());
    });
  }, [
    motivosLiquidacion,
    operaciones,
    actualizarOperaciones,
    permiteSeleccionar,
    permiteEditar,
    permiteEliminar,
    soloLectura,
  ]);

  return (
    <div className="card shadow mb-4">
      <div className="card-header">
        <h6 className="m-0 font-weight-bold text-primary">Operaciones</h6>
      </div>
      <div className="card-body">
        <table
          className="table table-striped table-hover w-auto display"
          ref={tableRef}
        />
      </div>
    </div>
  );
}

export default OperacionesModificarMotivoLiquidacion;
